import React, { FC } from 'react';

import { useSelector } from 'react-redux';

import { CoreUtils } from '@nhl/nhl-breakaway-ui';
import { useGamePolling } from '@nhl/react-hooks/lib/useGamePolling';

import { StateType } from '~/redux/types';

import { useGameCenterLandingQuery, useGameCenterRightRailQuery } from '../../api';
import PreGame from '../../sections/landing/components/preGame/PreGame';
import Summary from '../../sections/landing/components/summary/Summary';

type Props = {
    gameId?: number;
};

const Landing: FC<Props> = ({ gameId }) => {
    const gameState = useSelector((state: StateType) => state.gameCenter?.gameState);
    const { data: game, isInitialLoad, refetch: refetchLanding } = useGameCenterLandingQuery(gameId);
    useGamePolling(refetchLanding, [game]);

    const { refetch: refetchRightRail } = useGameCenterRightRailQuery(gameId);
    useGamePolling(refetchRightRail, [game]);

    return CoreUtils.isPregame(gameState) ? (
        <PreGame game={game} gameId={gameId} isInitialLoad={isInitialLoad} />
    ) : (
        <Summary game={game} gameId={gameId} isInitialLoad={isInitialLoad} />
    );
};

export default Landing;
